/* bsKey — THE ONE balance-sheet / revenue key normalization.
 *
 * This rule was spelled TWICE: `normalizeBSKey` (AdminPage, private) built the keys the
 * onboarding payload WRITES, and `slugForRevenueKey` (computeHistoricalFinancials,
 * private) built the keys the Step-4b review bridge READS BACK. Two copies of one
 * derivation, with the bridge's own comment asserting the equivalence it could not
 * enforce ("The same normalization buildFinancialsPayload uses..."). §6 PRINCIPLE 0: the
 * cost of a parallel implementation is never the duplication, it is the silent drift —
 * and here the drift would be invisible, because a bridge that keys a revenue line
 * differently from the payload simply reads $0 for it and the review screen still adds up.
 *
 * MEASURED EQUIVALENT BEFORE THE MERGE, so the extraction is a provable no-op: 919
 * comparisons over 106 distinct names — every IS gl_name and every gl_line_mappings
 * gl_name/display_name on cid 3/8/36/40, plus an 18-input probe set including empty, null,
 * punctuation-only and case edge cases — 0 differing. Evidence: diffs/phase2-b7-verify.txt.
 *
 * ★★ THIS IS A THIRD JOB, AND IT MUST NOT BE MERGED WITH `slugifyGlName`.
 * utils/isLineKey.js's `slugifyGlName` is the IS-LINE-KEY rule: it maps '&', '/', ',', '.'
 * to a SPACE and expands '<$1000', so "Discounts/Refunds Given" becomes
 * `discounts_refunds_given`. THIS rule DELETES those characters, giving
 * `discountsrefunds_given`. They disagree, deliberately, and STORED DATA IS KEYED UNDER
 * THIS ONE — `defrev_data.is_actuals`, `revenue_module_mappings.gl_line_key`, and the
 * bs_actuals_meta leaf keys. Switching the revenue/BS path to the canonical IS rule is a
 * DATA MIGRATION across all three storage sites (a re-key with no Step-3 guard behind it),
 * not a tidy-up. Analysis: diffs/phase2-bridge-phase0.txt §5.
 */

/* The key normalization for a balance-sheet leaf and for a Skip'd revenue line's
 * `rev_<slug>` fallback id. Moved here VERBATIM from AdminPage.js — the regexes are
 * unchanged, character for character, because the keys already in the database were
 * produced by exactly this sequence. */
export function normalizeBSKey(name) {
    return (name || '').toLowerCase()
        .replace(/[^a-z0-9\s_]/g, '')
        .trim()
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '');
}
